/* unplugin-vue-components disabled */import script from "./CategoryProductManager.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryProductManager.vue?vue&type=script&setup=true&lang=js"

import "./CategoryProductManager.vue?vue&type=style&index=0&id=4ec32efe&lang=css"

const __exports__ = script;

export default __exports__